import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {DateFormatService} from 'dmmp-services'
import {MediaInterface} from '../../interfaces'

@Component({
  selector: 'dmmp-recent-articles',
  templateUrl: './recent-articles.component.html'
})
export class RecentArticlesComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  firstArticle

  medias: MediaInterface[] = [
    {style: 'max_1300x1300', media: '(min-width: 1301px)'},
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:351px)'},
    {style: 'file_entity_browser_thumbnail', media: '(max-width:350px) AND (min-width:326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]


  constructor(
    private dateFormatService: DateFormatService
  ) {
  }

  ngOnInit(): void {
    if (this.module?.content?.length > 0) {
      this.module?.content?.forEach(contentItem => {
        contentItem.created_at = this.dateFormatService.convertFromTimestampToDate(contentItem?.created_at)
      })
      this.firstArticle = {...this.module?.content[0]}
      this.module.content.splice(0, 1)
    }
  }

}
